import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// ── PWA Service Worker ────────────────────────────────────────────────────────
// Enables offline caching and makes the app installable.
// The service-worker.js file is auto-generated by CRA's build step (Workbox).
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[PWA] App is ready to work offline.');
  },
  onUpdate: (registration) => {
    // Notify the user that a new version is available.
    // Skip waiting so the new SW activates immediately, then reload.
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.dispatchEvent(new CustomEvent('pwa-update-available'));
  },
});
